import { render, staticRenderFns } from "./EmptyHolder.vue?vue&type=template&id=af34d498&scoped=true"
import script from "./EmptyHolder.vue?vue&type=script&lang=js"
export * from "./EmptyHolder.vue?vue&type=script&lang=js"
import style0 from "./EmptyHolder.vue?vue&type=style&index=0&id=af34d498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af34d498",
  null
  
)

export default component.exports